import "./style.scss";

interface QueryRadioProps<T> {
    selected?: string;
    options: T[];
    isChecked: (option: T, selected: string) => boolean;
    getLabel: (option: T) => string;
    callback: (option: T) => void;
}

const QueryRadio = <T,>({ selected, options, isChecked, getLabel, callback }: QueryRadioProps<T>) => {
    return (
        <div className="query-radio-wrapper">
            {options.map((option, index) => (
                <label key={index}>
                    <input type="radio" checked={isChecked(option, selected || "")} onChange={() => callback(option)} />
                    <div className="custom-radio">
                        <p>{getLabel(option)}</p>
                    </div>
                </label>
            ))}
        </div>
    );
};

export default QueryRadio;
